export default function Header(){
  return(
    <header className="App-header">SAM HOLLADAY</header>
  );
}   